import { AspectRatio, Flex, Stack } from '@chakra-ui/react';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';
import { Routes } from '@constants/routes';
import { defaultTransition } from '@constants/styles';
import { formatDate } from '@utils/formatDate';
import { getPublishDate } from '@utils/index';
import Image from 'next/image';
import Link from 'next/link';
import { titleCase } from 'title-case';

const ArticleCard = ({ stateData, index }) => {
  const isMsPage = !!stateData.planFCarriers;
  const publishedDateString = getPublishDate(index).toString();
  const formattedDateString = formatDate(publishedDateString);

  const postUrl = `${
    isMsPage ? Routes.bestMedicareSupplement : Routes.topRatedMedicareAdvantage
  }/${stateData.state.toLowerCase().replace(/ /g, '-')}`;

  const stateName = titleCase(stateData.state);
  const alt = `Scene of ${stateName}`;

  return (
    <Link href={postUrl}>
      <Flex
        flexDir={['column', 'column', 'column', 'row']}
        bg="white"
        borderRadius="10px"
        w={['100%', '100%', '600px', '800px']}
        mx="auto"
        h={['300px', '350px', '550px', '240px']}
        cursor="pointer"
        boxShadow="25px 25px 25px -30px rgba(0, 0, 0, 0.25)"
        overflow="hidden"
        transition={defaultTransition}
        _hover={{
          opacity: 0.7,
        }}
      >
        <AspectRatio width="100%" height="100%" flex={1} overflow="hidden">
          <Image alt={alt} src={stateData.image} width={600} height={330} />
        </AspectRatio>
        <Stack w={['100%', '100%', '100%', '50%']} spacing={[2, 2, 2]} p={[6, 6, 10]}>
          <Header as="h3">
            Best Medicare {isMsPage ? 'Supplement' : 'Advantage'} Plans in {stateName} for 2025
          </Header>
          <Body1>{formattedDateString}</Body1>
        </Stack>
      </Flex>
    </Link>
  );
};

export default ArticleCard;
